import React from 'react';
import PropTypes from 'prop-types';
import AsyncCreatableSelect from 'react-select/async-creatable';
import Select from 'react-select';
import { searchTagsWithOptions } from './request';
import * as Classes from './styles.module.scss';

const TagEditor = ({
  basePath,
  options,
  onChange,
  ...rest
}) => {
  const loadOptions = basePath ? ((query) => searchTagsWithOptions(query, basePath)) : null;

  const Klass = basePath ? AsyncCreatableSelect : Select;

  const onValueChanged = (selectedValue) => {
    if (selectedValue) {
      const values = selectedValue.map((v) => v.value);
      onChange(values);
    }
  };

  return (
    <div className={ Classes.te }>
      <Klass
        defaultOptions={ [] }
        { ...rest }
        isMulti
        loadOptions={ loadOptions }
        options={ options }
        onChange={ onValueChanged }
      />
    </div>
  );
};

TagEditor.propTypes = {
  basePath: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })),
  onChange: PropTypes.func.isRequired
};

export default TagEditor;
